import { UserApi } from './userApi';

const userApi = new UserApi();

export { userApi };
